namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class ElPodaniPrehledPotvrzDorucAC extends GContentBase<PodListBaseAC>
    {
        model: Gordic.Wfl.Client.GElPodaniPrehledFilterDto;

        onContentReady() {
            var that = this;
            PodListBaseAC.InitList(this);
            this.specialActions.push(PodListBaseAC.CreateActionZobrazitPotvrzeniODoruceni(this, true));
            Gordic.Wfl.ListAC.WflListBaseAC.CompleteMenu(this);

            // samotná definice gfilterpanelu
            this.filterForm = $("<div>")
                .appendTo(this.element)
                .on("gfilterpanelapply", function (event, obj) {         // eventa která je vyvolána při vyhledávání. obj.filter -> hledaný seznam podmínek
                    that.LoadData(obj.filter);
                }).gfilterpanel({
                    forms: this.CreateFilterForms(), // poleFormu ktere budou pouzity pro podminky
                    favorites: ["datum"],                           // defaultní oblíbené
                    filterStorageService: new Gordic.Gin.FilterStorageService.Store({ tema: "pod_ptm_prepod" }),
                    favoriteLayoutDescriptor: Gordic.Gin.Globals.Enums.LayoutDescriptorType.list,
                    poVyhledaniZobrazit: "OblibenePodminky"               
                });
            this.CreateGrid();
            this.filterForm.gfilterpanel("applyFilter", this.model, !this.NacistSeznamPriOtevreni)      
        }

        CreateFilterForms() {
            var that = this;
            var filterForm = new Gordic.Forms.Form({ name: "FormDocsList", tabLabel: "jres:23900223", layoutDescriptor: "L2M2S1, L-3-8-1, M-12-11-1, S-12-11-1, breaks-700-1000" }) 
                .addSection()
                .addRow({ label: "jres:23900052", name: "datum" })
                .addField("gdatecombobox", {
                    name: "DatumField",
                    model: "model.Datum=value.date",
                    defaultInitialValue: "all",
                    daysRangeMax: this.DaysRangeMax,
                    contextMenu: {
                        daysRange: 50
                    },
                    userSettings: this.userSettings,
                });

            return [filterForm];
        }

        CreateGrid(): void {
            var that = this;
            var gf = Gordic.Wfl.ListAC.WflListBaseAC.GetGridFormat();
            gf.addIconColumn(Gordic.Wfl.ListPrefabs.DelegateSSign());
            gf.addTextColumn(ListPrefabs.ixbColumn());                
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datPodaniColumn("jres:23900020")); //RC 23900020 : Datum dodání
            gf.addDateTimeColumn(ListPrefabs.datPrijColumn());
            gf.addDateTimeColumn(Gordic.Wfl.ListPrefabs.datZpracovaniColumn());
            gf.addTextColumn({ name: "stav_inb_txt", caption: "jres:23900026", width: 120, }) //RC 23900026 : Stav podání
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.ixpColumn());     
            //AddColumnZnacka();                    
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailFromColumn());
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.poznamkaColumn());    
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.mailboxColumn());
            gf.addTextColumn({ name: "mail_to1", caption: "jres:23900053", width: 120, }) //RC 23900053 : Adresát potvrzení
            gf.addTextColumn({ name: "mail_from1", caption: "jres:23900054", width: 120, }) //RC 23900054 : Odesilatel potvrzení
            gf.addTextColumn({ name: "predmet", caption: "jres:23900055", width: 120, }) //RC 23900055 : Předmět
            gf.addTextColumn({ name: "prilohy", caption: "jres:23900056", width: 120, }) //RC 23900056 : Přílohy
            gf.addTextColumn({ name: "poznamka1", caption: "jres:23900057", width: 120, }) //RC 23900057 : Obsah
            gf.addTextColumn(Gordic.Wfl.ListPrefabs.typDokumentuTxtColumn());

            var OpenElPodani = new GAction({     //obsluzna akce, ktera se spousti dbl clickem nad radkem
                name: "gridRowSelectedAct",
                run: function (ev, ctx) {
                    var rowData = ctx.cellInfo.data; //data, ze kterych byl vytvoren radek
                    var l_po: string[] = [];
                    l_po.push(rowData.ixb);
                    Gordic.Pod.Dialogs.OpenPotvrzeniODoruceniDlg(that, { IdEntity: rowData.ixb }, Global.Enums.ModOtevreni.showModalWindow);                }
            })
            this.gridOptions = {};
            this.gridOptions.searchColumns = ["ixb", "poznamka"];
            this.gridOptions.defaultAction = OpenElPodani;
            var grid = Gordic.Wfl.ListAC.WflListBaseAC.CreateGridBase(this, gf);
            this.mainGrid = grid;
            Gordic.Wfl.ListAC.WflListBaseAC.AfterCreateGrid(this);
        }

        LoadData(filtr?: Gordic.Wfl.Client.GElPodaniPrehledFilterDto)
        {           
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            //nacteni dat do gridu
            this.call<Gordic.Wfl.Interface.GElPodaniDto[]>("LoadData", { "model": filtr})
                .done(function (data) {
                    var view = new Gordic.Data.View(data, { key: that.IDPrimaryKeyGridu });  //key je dulezity kvuli pripadnemu vyhledavani radku
                    that.mainGrid.ggrid("setData", view); 
                    //  } catch (e) { console.log("e", e) }

                })
                .always(function () {
                    Gordic.Wfl.ListAC.WflListBaseAC.AfterLoadData(that);
                });
        }

        ReloadData()
        {
            this.LoadData(this.model);
        }
    }
}
